import { useState } from 'react';
import { PanelTitle } from './PanelTitle';

/** Insignia de Beta Tester (contas do closed beta) — nao existe no mock, mantida do painel antigo. */
export function AchievementsPanel({ playTime }: { playTime: number }) {
  const [open, setOpen] = useState(false);
  return (
    <section className="panel-surface gifts-panel">
      <PanelTitle icon="♜" title="Conquistas Liberty" subtitle="Recompensas por sua jornada" />
      <article className="gift-card goldgift" style={{ gridTemplateColumns: '58px 1fr auto' }}>
        <img src="/assets/reward1.webp" alt="Beta Tester" style={{ width: 54, height: 54, objectFit: 'cover' }} />
        <div>
          <small>Exclusiva</small>
          <strong>Eu fui um Beta Tester</strong>
          <p style={{ margin: 0, color: '#aab3bc', fontSize: 9 }}>
            Participou do closed beta com mais de 4 horas de jogo. Tempo registrado: {Math.floor(playTime / 60)}h {playTime % 60}m
          </p>
        </div>
        <button className="btn btn-dark" onClick={() => setOpen(true)} style={{ width: 'auto', height: 'auto' }}>Coletar insígnia</button>
      </article>

      {open && (
        <div className="lb-modal-backdrop" onMouseDown={() => setOpen(false)}>
          <div className="lb-modal ornate-card" onMouseDown={(e) => e.stopPropagation()}>
            <h3>Eu fui um Beta Tester</h3>
            <p>Sua recompensa será liberada em breve.<br />Fique atento às novidades!</p>
            <button className="btn btn-gold submit-btn" onClick={() => setOpen(false)}>Entendido</button>
          </div>
        </div>
      )}
    </section>
  );
}
